export function openClose(type: string = "spring", duration: number = 0.5) {
  return {
    enter: {
      x: 0,
      opacity: 1,
      transition: { type, duration },
    },
    exit: {
      x: "-100%",
      opacity: 0,
      transition: { type, duration },
    },
  };
}
